import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { AppSharedUIModule, DialogService } from 'app-shared-ui';
import { TranslocoRootModule } from 'app-core';

import { AuthGuard } from '../guards/auth.guard';
import { ClinicAppointmentsComponent } from './appointments/appointments.component';
import { SelectClinicsComponent } from './select-clinics/select-clinics.component';
import { EditPrescriptionComponent } from './edit-prescription.component/edit-prescription.component';
import { PrintPrescriptionComponent } from './print-prescription.component/print-prescription.component';
import { AlphaPrescriptionPrinterModule } from 'alpha-prescription-printer';

@NgModule({
  declarations: [
    ClinicAppointmentsComponent,
    EditPrescriptionComponent,
    PrintPrescriptionComponent,
    SelectClinicsComponent
  ],
  imports: [
    AlphaPrescriptionPrinterModule,
    AppSharedUIModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: 'clinic/appointments',
        component: SelectClinicsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'clinic/appointments/:id',
        component: ClinicAppointmentsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'clinic/appointments/prescription/:id',
        component: EditPrescriptionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'clinic/appointments/prescription/edit/:id',
        component: PrintPrescriptionComponent,
        canActivate: [AuthGuard]
      },
    ]),
    TranslocoRootModule,
  ],
  providers: [
    DialogService
  ],
})
export class ClinicsModule { }
